import React from "react";
import { Input, message, Select } from "antd";
import { BottomFillIcon, ConfirmFillIcon, RoundIcon, TopFillIcon, WarningFillIcon } from "@t8891/icon";
import SplitText from "@Components/SplitText";

const { Option } = Select;

export const SexItem: React.FC<any> = ({ setFormData, formData, setQuery, toggle2 }) => {
  const { fristTimeSex, sex } = formData;
  return (
    <div id={"SexItem"} className='w-108 h-30 ml-14'>
      <Select
        placeholder='請選擇使用對象'
        onChange={(value) => {
          setFormData({ sex: value, fristTimeSex: false });
        }}
        value={sex}
        style={{ color: fristTimeSex ? "#999" : "#333", borderColor: "#E8E8E8", borderRadius: "4px" }}
        dropdownStyle={{ borderRadius: "4px", borderColor: "#E8E8E8" }}
        onBlur={() => {
          setQuery({ toggle2: false });
        }}
        className='w-full'
        onDropdownVisibleChange={() => {
          setQuery({ toggle2: true });
        }}
        suffixIcon={toggle2 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
      >
        <Option value={1}> 先生 </Option>
        <Option value={2}> 小姐 </Option>
      </Select>
    </div>
  );
};

/** 稱呼 */
export const RenderNameInput: React.FC<any> = ({
  placeholder,
  nameTips,
  name,
  onValChange,
  tracking,
  rightContent,
}) => {
  return (
    <div className='w-full relative mb-24 flex items-center' id='RenderNameInput'>
      {nameTips !== "" && <span className='absolute top-38 left-88 text-[#ff0000] leading-14 h-14'>{nameTips}</span>}
      <div className={`w-86 relative flex`}>
        <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
        <SplitText label='稱呼' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <div className='flex-1'>
        <Input
          onChange={(e) => onValChange(e.target.value, "name", false)}
          onBlur={(e) => {
            onValChange(e.target.value, "name", true);
            !!tracking &&
              tracking.trackEvent({
                name: "element_clicked",
                params: {
                  expand: e.target.value,
                  page_sub_business: "新車線索",
                  page_business: "新車",
                  trigger_id: "2020",
                  page_id: "108",
                  trigger_name: "稱呼填寫",
                  next_spm: "3.108.272.709",
                  page: "詢價提交頁-資料填寫",
                  channel: "新車",
                  element_id: "稱呼填寫",
                  element: "表單項",
                  module: "一鍵詢價按鈕",
                  tracker_method: "config",
                },
              });
          }}
          style={{ borderRadius: "4px", borderColor: "#E8E8E8" }}
          placeholder={placeholder || "例如陳先生/小姐"}
          value={name}
          maxLength={10}
        />
      </div>
      {rightContent}
    </div>
  );
};

/** 接听时间 */
export const RenderAnswerDateSelect: React.FC<any> = ({ setFormData, formData, setQuery, toggle1, inquiryOptions }) => {
  return (
    <section className='w-full relative mb-24 flex items-center'>
      <div className={`w-86 relative flex`}>
        <SplitText label='接聽時間' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <div className='flex-1'>
        <Select
          placeholder='請選擇接聽時間'
          onChange={(value) => {
            setFormData({ contactTime: value });
          }}
          value={formData.contactTime}
          onBlur={() => {
            // setToggle1(false);
            setQuery({ toggle1: false });
          }}
          className='w-full'
          onDropdownVisibleChange={() => {
            // setToggle1(true);
            setQuery({ toggle1: true });
          }}
          suffixIcon={toggle1 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        >
          {Array.isArray(inquiryOptions?.contactTime) &&
            inquiryOptions.contactTime.map((item) => (
              <Option value={item.value} key={item.name}>
                {item.name}
              </Option>
            ))}
        </Select>
      </div>
    </section>
  );
};

// 购车使用
const reasonData = [
  {
    label: "自己使用",
    value: "自己使用",
  },
  {
    label: "給小孩使用",
    value: "給小孩使用",
  },
  {
    label: "給伴侶使用",
    value: "給伴侶使用",
  },
  {
    label: "其他",
    value: "其他",
  },
];

/** 購車使用 */
export const BuyCarReason: React.FC<any> = ({ setFormData, formData, setQuery, toggle2, inquiryOptions }) => {
  const { fristTimeReason } = formData;
  return (
    <section className='w-full relative mb-24 flex items-center'>
      <div className={`w-86 relative flex`}>
        <SplitText label='購車使用' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <div className='flex-1'>
        <Select
          placeholder='請選擇使用對象'
          onChange={(value) => {
            setFormData({ reason: value, fristTimeReason: false });
          }}
          value={formData.reason}
          style={{ color: fristTimeReason ? "#999" : "#333" }}
          onBlur={() => {
            setQuery({ toggle2: false });
          }}
          className='w-full'
          onDropdownVisibleChange={() => {
            setQuery({ toggle2: true });
          }}
          suffixIcon={toggle2 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        >
          {reasonData.map((item) => (
            <Option value={item.value} key={item.value}>
              {item.value}
            </Option>
          ))}
        </Select>
      </div>
    </section>
  );
};

// 購車類型
const purchasesData = [
  {
    label: "初購(第一次購車)",
    value: "初購(第一次購車)",
  },
  {
    label: "增購(已有不止一台車)",
    value: "增購(已有不止一台車)",
  },
  {
    label: "換購",
    value: "換購",
  },
];

/** 購車類型 */
export const BuyCarPurchases: React.FC<any> = ({ setFormData, formData, setQuery, toggle2, inquiryOptions }) => {
  const { fristTimePurchases } = formData;

  return (
    <section className='w-full relative mb-24 flex items-center'>
      <div className={`w-86 relative flex`}>
        <SplitText label='購車類型' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <div className='flex-1'>
        <Select
          placeholder='請選擇購車類型'
          onChange={(value) => {
            setFormData({ purchases: value, fristTimePurchases: false });
          }}
          value={formData.purchases}
          style={{ color: fristTimePurchases ? "#999" : "#333" }}
          onBlur={() => {
            setQuery({ toggle2: false });
          }}
          className='w-full'
          onDropdownVisibleChange={() => {
            setQuery({ toggle2: true });
          }}
          suffixIcon={toggle2 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
        >
          {purchasesData.map((item) => (
            <Option value={item.value} key={item.value}>
              {item.value}
            </Option>
          ))}
        </Select>
      </div>
    </section>
  );
};

/** 郵箱 */
export const EmailItem: React.FC<any> = ({ tips, name, onValChange }) => {
  return (
    <div id='EmailItem' className='w-full relative mb-24 flex items-center'>
      {tips !== "" && <span className='absolute top-38 left-88 text-[#ff0000] leading-14 h-14'>{tips}</span>}
      <div className={`w-86 relative flex`}>
        <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
        <SplitText label='郵箱' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <div className='flex-1'>
        <Input
          onChange={(e) => onValChange(e.target.value, "email", false)}
          onBlur={(e) => {
            onValChange(e.target.value, "email", true);
          }}
          style={{ borderRadius: "4px", borderColor: "#E8E8E8" }}
          placeholder={"請填寫您的E-mail"}
          value={name}
          maxLength={25}
        />
      </div>
    </div>
  );
};

/** 年龄 */

export const AgeItem: React.FC<any> = ({ ageData, setFormData, formData, setQuery, toggle2 }) => {
  const { fristTimeAge, age } = formData;
  return (
    <div id='AgeItem' className='w-full relative mb-24 flex items-center gap-10'>
      <div className={`w-86 relative flex`}>
        <span className='absolute text-[#ff4333] -left-10 to-4'></span>
        <SplitText label='年齡' width={64} cls='text-[#333] font-medium text-16 leading-18'></SplitText>：
      </div>
      <Select
        placeholder='請選擇年齡'
        onChange={(value) => {
          setFormData({ age: value, fristTimeAge: false });
        }}
        value={age}
        style={{ color: fristTimeAge ? "#999" : "#333", borderColor: "#E8E8E8", borderRadius: "8px" }}
        dropdownStyle={{ borderRadius: "4px", borderColor: "#E8E8E8" }}
        onBlur={() => {
          setQuery({ toggle2: false });
        }}
        className='w-full'
        onDropdownVisibleChange={() => {
          setQuery({ toggle2: true });
        }}
        suffixIcon={toggle2 ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
      >
        {ageData.map((item: any, index: number) => (
          <Option value={item.value} key={index}>
            {item.name}
          </Option>
        ))}
      </Select>
    </div>
  );
};
